import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: ['List'],
  data: function data() {
    return {
      ArrList: []
    };
  },
  methods: {
    //添加输入框
    AddInput: function AddInput() {
      this.ArrList.push({
        value: ''
      });
    },
    //删除输入框
    DeleTeInput: function DeleTeInput(index) {
      this.ArrList.splice(index, 1);
    },
    //转换成字符串数组
    SetArrList: function SetArrList(Arr) {
      //创建字符串数组
      var ArrList = []; //筛选不为空的对象数组

      Arr.map(function (val, index) {
        if (val.value !== '') {
          ArrList.push(val.value);
        }
      }); // console.log(ArrList)
      //返回字符串数组

      return ArrList;
    },
    //验证
    ArrAddInputError: function ArrAddInputError() {
      var _this = this;

      var test = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      var retu = false;
      this.ArrList.forEach(function (val, index) {
        if (!test.test(val.value)) {
          _this.error = true;
          retu = true;
          return;
        }
      });

      if (!retu) {
        this.error = false;
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    setTimeout(function () {
      if (_this2.List.length > 0) {
        _this2.ArrList = _this2.List.map(function (val, index) {
          return {
            value: val
          };
        });
      } else {
        _this2.ArrList = [];

        _this2.ArrList.push({
          value: ''
        });
      }
    }, 1500);
  },
  watch: {
    ArrList: {
      handler: function handler(newvalue, oldValue) {
        //返回字符串数组
        this.$emit('GetArrList', this.SetArrList(this.ArrList));
      },
      deep: true
    },
    List: {
      handler: function handler(newValue, oldValue) {// console.log(newValue)
      }
    },
    deep: true
  }
};